// cspell:disable

import { isEnumValue } from "@redotech/util/enum";
import { CountryCode } from "../inventory/shopify-listing/common-schemas";
import { reverseRecord } from "../records-utils";

// This is a copy of the CountryCode enum from "@redotech/shopify-client/admin.graphql, but that can also be used in redo/model and therefore the frontend
export enum RedoShopifyCountryCode {
  /** Ascension Island. */
  Ac = "AC",
  /** Andorra. */
  Ad = "AD",
  /** United Arab Emirates. */
  Ae = "AE",
  /** Afghanistan. */
  Af = "AF",
  /** Antigua & Barbuda. */
  Ag = "AG",
  /** Anguilla. */
  Ai = "AI",
  /** Albania. */
  Al = "AL",
  /** Armenia. */
  Am = "AM",
  /** Netherlands Antilles. */
  An = "AN",
  /** Angola. */
  Ao = "AO",
  /** Argentina. */
  Ar = "AR",
  /** American Samoa */
  As = "AS",
  /** Austria. */
  At = "AT",
  /** Australia. */
  Au = "AU",
  /** Aruba. */
  Aw = "AW",
  /** Åland Islands. */
  Ax = "AX",
  /** Azerbaijan. */
  Az = "AZ",
  /** Bosnia & Herzegovina. */
  Ba = "BA",
  /** Barbados. */
  Bb = "BB",
  /** Bangladesh. */
  Bd = "BD",
  /** Belgium. */
  Be = "BE",
  /** Burkina Faso. */
  Bf = "BF",
  /** Bulgaria. */
  Bg = "BG",
  /** Bahrain. */
  Bh = "BH",
  /** Burundi. */
  Bi = "BI",
  /** Benin. */
  Bj = "BJ",
  /** St. Barthélemy. */
  Bl = "BL",
  /** Bermuda. */
  Bm = "BM",
  /** Brunei. */
  Bn = "BN",
  /** Bolivia. */
  Bo = "BO",
  /** Caribbean Netherlands. */
  Bq = "BQ",
  /** Brazil. */
  Br = "BR",
  /** Bahamas. */
  Bs = "BS",
  /** Bhutan. */
  Bt = "BT",
  /** Bouvet Island. */
  Bv = "BV",
  /** Botswana. */
  Bw = "BW",
  /** Belarus. */
  By = "BY",
  /** Belize. */
  Bz = "BZ",
  /** Canada. */
  Ca = "CA",
  /** Cocos (Keeling) Islands. */
  Cc = "CC",
  /** Congo - Kinshasa. */
  Cd = "CD",
  /** Central African Republic. */
  Cf = "CF",
  /** Congo - Brazzaville. */
  Cg = "CG",
  /** Switzerland. */
  Ch = "CH",
  /** Côte d'Ivoire. */
  Ci = "CI",
  /** Cook Islands. */
  Ck = "CK",
  /** Chile. */
  Cl = "CL",
  /** Cameroon. */
  Cm = "CM",
  /** China. */
  Cn = "CN",
  /** Colombia. */
  Co = "CO",
  /** Costa Rica. */
  Cr = "CR",
  /** Cuba. */
  Cu = "CU",
  /** Cape Verde. */
  Cv = "CV",
  /** Curaçao. */
  Cw = "CW",
  /** Christmas Island. */
  Cx = "CX",
  /** Cyprus. */
  Cy = "CY",
  /** Czechia. */
  Cz = "CZ",
  /** Germany. */
  De = "DE",
  /** Djibouti. */
  Dj = "DJ",
  /** Denmark. */
  Dk = "DK",
  /** Dominica. */
  Dm = "DM",
  /** Dominican Republic. */
  Do = "DO",
  /** Algeria. */
  Dz = "DZ",
  /** Ecuador. */
  Ec = "EC",
  /** Estonia. */
  Ee = "EE",
  /** Egypt. */
  Eg = "EG",
  /** Western Sahara. */
  Eh = "EH",
  /** Eritrea. */
  Er = "ER",
  /** Spain. */
  Es = "ES",
  /** Ethiopia. */
  Et = "ET",
  /** Finland. */
  Fi = "FI",
  /** Fiji. */
  Fj = "FJ",
  /** Falkland Islands. */
  Fk = "FK",
  /** Faroe Islands. */
  Fo = "FO",
  /** France. */
  Fr = "FR",
  /** Gabon. */
  Ga = "GA",
  /** United Kingdom. */
  Gb = "GB",
  /** Grenada. */
  Gd = "GD",
  /** Georgia. */
  Ge = "GE",
  /** French Guiana. */
  Gf = "GF",
  /** Guernsey. */
  Gg = "GG",
  /** Ghana. */
  Gh = "GH",
  /** Gibraltar. */
  Gi = "GI",
  /** Greenland. */
  Gl = "GL",
  /** Gambia. */
  Gm = "GM",
  /** Guinea. */
  Gn = "GN",
  /** Guadeloupe. */
  Gp = "GP",
  /** Equatorial Guinea. */
  Gq = "GQ",
  /** Greece. */
  Gr = "GR",
  /** South Georgia & South Sandwich Islands. */
  Gs = "GS",
  /** Guatemala. */
  Gt = "GT",
  /** Guam. */
  Gu = "GU",
  /** Guinea-Bissau. */
  Gw = "GW",
  /** Guyana. */
  Gy = "GY",
  /** Hong Kong SAR. */
  Hk = "HK",
  /** Heard & McDonald Islands. */
  Hm = "HM",
  /** Honduras. */
  Hn = "HN",
  /** Croatia. */
  Hr = "HR",
  /** Haiti. */
  Ht = "HT",
  /** Hungary. */
  Hu = "HU",
  /** Indonesia. */
  Id = "ID",
  /** Ireland. */
  Ie = "IE",
  /** Israel. */
  Il = "IL",
  /** Isle of Man. */
  Im = "IM",
  /** India. */
  In = "IN",
  /** British Indian Ocean Territory. */
  Io = "IO",
  /** Iraq. */
  Iq = "IQ",
  /** Iran. */
  Ir = "IR",
  /** Iceland. */
  Is = "IS",
  /** Italy. */
  It = "IT",
  /** Jersey. */
  Je = "JE",
  /** Jamaica. */
  Jm = "JM",
  /** Jordan. */
  Jo = "JO",
  /** Japan. */
  Jp = "JP",
  /** Kenya. */
  Ke = "KE",
  /** Kyrgyzstan. */
  Kg = "KG",
  /** Cambodia. */
  Kh = "KH",
  /** Kiribati. */
  Ki = "KI",
  /** Comoros. */
  Km = "KM",
  /** St. Kitts & Nevis. */
  Kn = "KN",
  /** North Korea. */
  Kp = "KP",
  /** South Korea. */
  Kr = "KR",
  /** Kuwait. */
  Kw = "KW",
  /** Cayman Islands. */
  Ky = "KY",
  /** Kazakhstan. */
  Kz = "KZ",
  /** Laos. */
  La = "LA",
  /** Lebanon. */
  Lb = "LB",
  /** St. Lucia. */
  Lc = "LC",
  /** Liechtenstein. */
  Li = "LI",
  /** Sri Lanka. */
  Lk = "LK",
  /** Liberia. */
  Lr = "LR",
  /** Lesotho. */
  Ls = "LS",
  /** Lithuania. */
  Lt = "LT",
  /** Luxembourg. */
  Lu = "LU",
  /** Latvia. */
  Lv = "LV",
  /** Libya. */
  Ly = "LY",
  /** Morocco. */
  Ma = "MA",
  /** Monaco. */
  Mc = "MC",
  /** Moldova. */
  Md = "MD",
  /** Montenegro. */
  Me = "ME",
  /** St. Martin. */
  Mf = "MF",
  /** Madagascar. */
  Mg = "MG",
  /** North Macedonia. */
  Mk = "MK",
  /** Mali. */
  Ml = "ML",
  /** Myanmar (Burma). */
  Mm = "MM",
  /** Mongolia. */
  Mn = "MN",
  /** Macao SAR. */
  Mo = "MO",
  /** Martinique. */
  Mq = "MQ",
  /** Mauritania. */
  Mr = "MR",
  /** Montserrat. */
  Ms = "MS",
  /** Malta. */
  Mt = "MT",
  /** Mauritius. */
  Mu = "MU",
  /** Maldives. */
  Mv = "MV",
  /** Malawi. */
  Mw = "MW",
  /** Mexico. */
  Mx = "MX",
  /** Malaysia. */
  My = "MY",
  /** Mozambique. */
  Mz = "MZ",
  /** Namibia. */
  Na = "NA",
  /** New Caledonia. */
  Nc = "NC",
  /** Niger. */
  Ne = "NE",
  /** Norfolk Island. */
  Nf = "NF",
  /** Nigeria. */
  Ng = "NG",
  /** Nicaragua. */
  Ni = "NI",
  /** Netherlands. */
  Nl = "NL",
  /** Norway. */
  No = "NO",
  /** Nepal. */
  Np = "NP",
  /** Nauru. */
  Nr = "NR",
  /** Niue. */
  Nu = "NU",
  /** New Zealand. */
  Nz = "NZ",
  /** Oman. */
  Om = "OM",
  /** Panama. */
  Pa = "PA",
  /** Peru. */
  Pe = "PE",
  /** French Polynesia. */
  Pf = "PF",
  /** Papua New Guinea. */
  Pg = "PG",
  /** Philippines. */
  Ph = "PH",
  /** Pakistan. */
  Pk = "PK",
  /** Poland. */
  Pl = "PL",
  /** St. Pierre & Miquelon. */
  Pm = "PM",
  /** Pitcairn Islands. */
  Pn = "PN",
  /** Puerto Rico */
  /** Not found in shopify */
  Pr = "PR",
  /** Palestinian Territories. */
  Ps = "PS",
  /** Portugal. */
  Pt = "PT",
  /** Paraguay. */
  Py = "PY",
  /** Qatar. */
  Qa = "QA",
  /** Réunion. */
  Re = "RE",
  /** Romania. */
  Ro = "RO",
  /** Serbia. */
  Rs = "RS",
  /** Russia. */
  Ru = "RU",
  /** Rwanda. */
  Rw = "RW",
  /** Saudi Arabia. */
  Sa = "SA",
  /** Solomon Islands. */
  Sb = "SB",
  /** Seychelles. */
  Sc = "SC",
  /** Sudan. */
  Sd = "SD",
  /** Sweden. */
  Se = "SE",
  /** Singapore. */
  Sg = "SG",
  /** St. Helena. */
  Sh = "SH",
  /** Slovenia. */
  Si = "SI",
  /** Svalbard & Jan Mayen. */
  Sj = "SJ",
  /** Slovakia. */
  Sk = "SK",
  /** Sierra Leone. */
  Sl = "SL",
  /** San Marino. */
  Sm = "SM",
  /** Senegal. */
  Sn = "SN",
  /** Somalia. */
  So = "SO",
  /** Suriname. */
  Sr = "SR",
  /** South Sudan. */
  Ss = "SS",
  /** São Tomé & Príncipe. */
  St = "ST",
  /** El Salvador. */
  Sv = "SV",
  /** Sint Maarten. */
  Sx = "SX",
  /** Syria. */
  Sy = "SY",
  /** Eswatini. */
  Sz = "SZ",
  /** Tristan da Cunha. */
  Ta = "TA",
  /** Turks & Caicos Islands. */
  Tc = "TC",
  /** Chad. */
  Td = "TD",
  /** French Southern Territories. */
  Tf = "TF",
  /** Togo. */
  Tg = "TG",
  /** Thailand. */
  Th = "TH",
  /** Tajikistan. */
  Tj = "TJ",
  /** Tokelau. */
  Tk = "TK",
  /** Timor-Leste. */
  Tl = "TL",
  /** Turkmenistan. */
  Tm = "TM",
  /** Tunisia. */
  Tn = "TN",
  /** Tonga. */
  To = "TO",
  /** Türkiye. */
  Tr = "TR",
  /** Trinidad & Tobago. */
  Tt = "TT",
  /** Tuvalu. */
  Tv = "TV",
  /** Taiwan. */
  Tw = "TW",
  /** Tanzania. */
  Tz = "TZ",
  /** Ukraine. */
  Ua = "UA",
  /** Uganda. */
  Ug = "UG",
  /** U.S. Outlying Islands. */
  Um = "UM",
  /** United States. */
  Us = "US",
  /** Uruguay. */
  Uy = "UY",
  /** Uzbekistan. */
  Uz = "UZ",
  /** Vatican City. */
  Va = "VA",
  /** St. Vincent & Grenadines. */
  Vc = "VC",
  /** Venezuela. */
  Ve = "VE",
  /** British Virgin Islands. */
  Vg = "VG",
  /** U.S. Virgin Islands. */
  Vi = "VI",
  /** Vietnam. */
  Vn = "VN",
  /** Vanuatu. */
  Vu = "VU",
  /** Wallis & Futuna. */
  Wf = "WF",
  /** Samoa. */
  Ws = "WS",
  /** Kosovo. */
  Xk = "XK",
  /** Yemen. */
  Ye = "YE",
  /** Mayotte. */
  Yt = "YT",
  /** South Africa. */
  Za = "ZA",
  /** Zambia. */
  Zm = "ZM",
  /** Zimbabwe. */
  Zw = "ZW",
  /** Unknown Region. */
  Zz = "ZZ",
}

export const RedoShopifyCountryNames: Record<RedoShopifyCountryCode, string> = {
  [RedoShopifyCountryCode.Ac]: "Ascension Island",
  [RedoShopifyCountryCode.Ad]: "Andorra",
  [RedoShopifyCountryCode.Ae]: "United Arab Emirates",
  [RedoShopifyCountryCode.Af]: "Afghanistan",
  [RedoShopifyCountryCode.Ag]: "Antigua & Barbuda",
  [RedoShopifyCountryCode.Ai]: "Anguilla",
  [RedoShopifyCountryCode.Al]: "Albania",
  [RedoShopifyCountryCode.Am]: "Armenia",
  [RedoShopifyCountryCode.An]: "Netherlands Antilles",
  [RedoShopifyCountryCode.Ao]: "Angola",
  [RedoShopifyCountryCode.Ar]: "Argentina",
  [RedoShopifyCountryCode.As]: "American Samoa",
  [RedoShopifyCountryCode.At]: "Austria",
  [RedoShopifyCountryCode.Au]: "Australia",
  [RedoShopifyCountryCode.Aw]: "Aruba",
  [RedoShopifyCountryCode.Ax]: "Åland Islands",
  [RedoShopifyCountryCode.Az]: "Azerbaijan",
  [RedoShopifyCountryCode.Ba]: "Bosnia & Herzegovina",
  [RedoShopifyCountryCode.Bb]: "Barbados",
  [RedoShopifyCountryCode.Bd]: "Bangladesh",
  [RedoShopifyCountryCode.Be]: "Belgium",
  [RedoShopifyCountryCode.Bf]: "Burkina Faso",
  [RedoShopifyCountryCode.Bg]: "Bulgaria",
  [RedoShopifyCountryCode.Bh]: "Bahrain",
  [RedoShopifyCountryCode.Bi]: "Burundi",
  [RedoShopifyCountryCode.Bj]: "Benin",
  [RedoShopifyCountryCode.Bl]: "St. Barthélemy",
  [RedoShopifyCountryCode.Bm]: "Bermuda",
  [RedoShopifyCountryCode.Bn]: "Brunei",
  [RedoShopifyCountryCode.Bo]: "Bolivia",
  [RedoShopifyCountryCode.Bq]: "Caribbean Netherlands",
  [RedoShopifyCountryCode.Br]: "Brazil",
  [RedoShopifyCountryCode.Bs]: "Bahamas",
  [RedoShopifyCountryCode.Bt]: "Bhutan",
  [RedoShopifyCountryCode.Bv]: "Bouvet Island",
  [RedoShopifyCountryCode.Bw]: "Botswana",
  [RedoShopifyCountryCode.By]: "Belarus",
  [RedoShopifyCountryCode.Bz]: "Belize",
  [RedoShopifyCountryCode.Ca]: "Canada",
  [RedoShopifyCountryCode.Cc]: "Cocos (Keeling) Islands",
  [RedoShopifyCountryCode.Cd]: "Congo - Kinshasa",
  [RedoShopifyCountryCode.Cf]: "Central African Republic",
  [RedoShopifyCountryCode.Cg]: "Congo - Brazzaville",
  [RedoShopifyCountryCode.Ch]: "Switzerland",
  [RedoShopifyCountryCode.Ci]: "Côte d'Ivoire",
  [RedoShopifyCountryCode.Ck]: "Cook Islands",
  [RedoShopifyCountryCode.Cl]: "Chile",
  [RedoShopifyCountryCode.Cm]: "Cameroon",
  [RedoShopifyCountryCode.Cn]: "China",
  [RedoShopifyCountryCode.Co]: "Colombia",
  [RedoShopifyCountryCode.Cr]: "Costa Rica",
  [RedoShopifyCountryCode.Cu]: "Cuba",
  [RedoShopifyCountryCode.Cv]: "Cape Verde",
  [RedoShopifyCountryCode.Cw]: "Curaçao",
  [RedoShopifyCountryCode.Cx]: "Christmas Island",
  [RedoShopifyCountryCode.Cy]: "Cyprus",
  [RedoShopifyCountryCode.Cz]: "Czechia",
  [RedoShopifyCountryCode.De]: "Germany",
  [RedoShopifyCountryCode.Dj]: "Djibouti",
  [RedoShopifyCountryCode.Dk]: "Denmark",
  [RedoShopifyCountryCode.Dm]: "Dominica",
  [RedoShopifyCountryCode.Do]: "Dominican Republic",
  [RedoShopifyCountryCode.Dz]: "Algeria",
  [RedoShopifyCountryCode.Ec]: "Ecuador",
  [RedoShopifyCountryCode.Ee]: "Estonia",
  [RedoShopifyCountryCode.Eg]: "Egypt",
  [RedoShopifyCountryCode.Eh]: "Western Sahara",
  [RedoShopifyCountryCode.Er]: "Eritrea",
  [RedoShopifyCountryCode.Es]: "Spain",
  [RedoShopifyCountryCode.Et]: "Ethiopia",
  [RedoShopifyCountryCode.Fi]: "Finland",
  [RedoShopifyCountryCode.Fj]: "Fiji",
  [RedoShopifyCountryCode.Fk]: "Falkland Islands",
  [RedoShopifyCountryCode.Fo]: "Faroe Islands",
  [RedoShopifyCountryCode.Fr]: "France",
  [RedoShopifyCountryCode.Ga]: "Gabon",
  [RedoShopifyCountryCode.Gb]: "United Kingdom",
  [RedoShopifyCountryCode.Gd]: "Grenada",
  [RedoShopifyCountryCode.Ge]: "Georgia",
  [RedoShopifyCountryCode.Gf]: "French Guiana",
  [RedoShopifyCountryCode.Gg]: "Guernsey",
  [RedoShopifyCountryCode.Gh]: "Ghana",
  [RedoShopifyCountryCode.Gi]: "Gibraltar",
  [RedoShopifyCountryCode.Gl]: "Greenland",
  [RedoShopifyCountryCode.Gm]: "Gambia",
  [RedoShopifyCountryCode.Gn]: "Guinea",
  [RedoShopifyCountryCode.Gp]: "Guadeloupe",
  [RedoShopifyCountryCode.Gq]: "Equatorial Guinea",
  [RedoShopifyCountryCode.Gr]: "Greece",
  [RedoShopifyCountryCode.Gs]: "South Georgia & South Sandwich Islands",
  [RedoShopifyCountryCode.Gt]: "Guatemala",
  [RedoShopifyCountryCode.Gu]: "Guam",
  [RedoShopifyCountryCode.Gw]: "Guinea-Bissau",
  [RedoShopifyCountryCode.Gy]: "Guyana",
  [RedoShopifyCountryCode.Hk]: "Hong Kong SAR",
  [RedoShopifyCountryCode.Hm]: "Heard & McDonald Islands",
  [RedoShopifyCountryCode.Hn]: "Honduras",
  [RedoShopifyCountryCode.Hr]: "Croatia",
  [RedoShopifyCountryCode.Ht]: "Haiti",
  [RedoShopifyCountryCode.Hu]: "Hungary",
  [RedoShopifyCountryCode.Id]: "Indonesia",
  [RedoShopifyCountryCode.Ie]: "Ireland",
  [RedoShopifyCountryCode.Il]: "Israel",
  [RedoShopifyCountryCode.Im]: "Isle of Man",
  [RedoShopifyCountryCode.In]: "India",
  [RedoShopifyCountryCode.Io]: "British Indian Ocean Territory",
  [RedoShopifyCountryCode.Iq]: "Iraq",
  [RedoShopifyCountryCode.Ir]: "Iran",
  [RedoShopifyCountryCode.Is]: "Iceland",
  [RedoShopifyCountryCode.It]: "Italy",
  [RedoShopifyCountryCode.Je]: "Jersey",
  [RedoShopifyCountryCode.Jm]: "Jamaica",
  [RedoShopifyCountryCode.Jo]: "Jordan",
  [RedoShopifyCountryCode.Jp]: "Japan",
  [RedoShopifyCountryCode.Ke]: "Kenya",
  [RedoShopifyCountryCode.Kg]: "Kyrgyzstan",
  [RedoShopifyCountryCode.Kh]: "Cambodia",
  [RedoShopifyCountryCode.Ki]: "Kiribati",
  [RedoShopifyCountryCode.Km]: "Comoros",
  [RedoShopifyCountryCode.Kn]: "St. Kitts & Nevis",
  [RedoShopifyCountryCode.Kp]: "North Korea",
  [RedoShopifyCountryCode.Kr]: "South Korea",
  [RedoShopifyCountryCode.Kw]: "Kuwait",
  [RedoShopifyCountryCode.Ky]: "Cayman Islands",
  [RedoShopifyCountryCode.Kz]: "Kazakhstan",
  [RedoShopifyCountryCode.La]: "Laos",
  [RedoShopifyCountryCode.Lb]: "Lebanon",
  [RedoShopifyCountryCode.Lc]: "St. Lucia",
  [RedoShopifyCountryCode.Li]: "Liechtenstein",
  [RedoShopifyCountryCode.Lk]: "Sri Lanka",
  [RedoShopifyCountryCode.Lr]: "Liberia",
  [RedoShopifyCountryCode.Ls]: "Lesotho",
  [RedoShopifyCountryCode.Lt]: "Lithuania",
  [RedoShopifyCountryCode.Lu]: "Luxembourg",
  [RedoShopifyCountryCode.Lv]: "Latvia",
  [RedoShopifyCountryCode.Ly]: "Libya",
  [RedoShopifyCountryCode.Ma]: "Morocco",
  [RedoShopifyCountryCode.Mc]: "Monaco",
  [RedoShopifyCountryCode.Md]: "Moldova",
  [RedoShopifyCountryCode.Me]: "Montenegro",
  [RedoShopifyCountryCode.Mf]: "St. Martin",
  [RedoShopifyCountryCode.Mg]: "Madagascar",
  [RedoShopifyCountryCode.Mk]: "North Macedonia",
  [RedoShopifyCountryCode.Ml]: "Mali",
  [RedoShopifyCountryCode.Mm]: "Myanmar (Burma)",
  [RedoShopifyCountryCode.Mn]: "Mongolia",
  [RedoShopifyCountryCode.Mo]: "Macao SAR",
  [RedoShopifyCountryCode.Mq]: "Martinique",
  [RedoShopifyCountryCode.Mr]: "Mauritania",
  [RedoShopifyCountryCode.Ms]: "Montserrat",
  [RedoShopifyCountryCode.Mt]: "Malta",
  [RedoShopifyCountryCode.Mu]: "Mauritius",
  [RedoShopifyCountryCode.Mv]: "Maldives",
  [RedoShopifyCountryCode.Mw]: "Malawi",
  [RedoShopifyCountryCode.Mx]: "Mexico",
  [RedoShopifyCountryCode.My]: "Malaysia",
  [RedoShopifyCountryCode.Mz]: "Mozambique",
  [RedoShopifyCountryCode.Na]: "Namibia",
  [RedoShopifyCountryCode.Nc]: "New Caledonia",
  [RedoShopifyCountryCode.Ne]: "Niger",
  [RedoShopifyCountryCode.Nf]: "Norfolk Island",
  [RedoShopifyCountryCode.Ng]: "Nigeria",
  [RedoShopifyCountryCode.Ni]: "Nicaragua",
  [RedoShopifyCountryCode.Nl]: "Netherlands",
  [RedoShopifyCountryCode.No]: "Norway",
  [RedoShopifyCountryCode.Np]: "Nepal",
  [RedoShopifyCountryCode.Nr]: "Nauru",
  [RedoShopifyCountryCode.Nu]: "Niue",
  [RedoShopifyCountryCode.Nz]: "New Zealand",
  [RedoShopifyCountryCode.Om]: "Oman",
  [RedoShopifyCountryCode.Pa]: "Panama",
  [RedoShopifyCountryCode.Pe]: "Peru",
  [RedoShopifyCountryCode.Pf]: "French Polynesia",
  [RedoShopifyCountryCode.Pg]: "Papua New Guinea",
  [RedoShopifyCountryCode.Ph]: "Philippines",
  [RedoShopifyCountryCode.Pk]: "Pakistan",
  [RedoShopifyCountryCode.Pl]: "Poland",
  [RedoShopifyCountryCode.Pm]: "St. Pierre & Miquelon",
  [RedoShopifyCountryCode.Pn]: "Pitcairn Islands",
  [RedoShopifyCountryCode.Pr]: "Puerto Rico",
  [RedoShopifyCountryCode.Ps]: "Palestinian Territories",
  [RedoShopifyCountryCode.Pt]: "Portugal",
  [RedoShopifyCountryCode.Py]: "Paraguay",
  [RedoShopifyCountryCode.Qa]: "Qatar",
  [RedoShopifyCountryCode.Re]: "Réunion",
  [RedoShopifyCountryCode.Ro]: "Romania",
  [RedoShopifyCountryCode.Rs]: "Serbia",
  [RedoShopifyCountryCode.Ru]: "Russia",
  [RedoShopifyCountryCode.Rw]: "Rwanda",
  [RedoShopifyCountryCode.Sa]: "Saudi Arabia",
  [RedoShopifyCountryCode.Sb]: "Solomon Islands",
  [RedoShopifyCountryCode.Sc]: "Seychelles",
  [RedoShopifyCountryCode.Sd]: "Sudan",
  [RedoShopifyCountryCode.Se]: "Sweden",
  [RedoShopifyCountryCode.Sg]: "Singapore",
  [RedoShopifyCountryCode.Sh]: "St. Helena",
  [RedoShopifyCountryCode.Si]: "Slovenia",
  [RedoShopifyCountryCode.Sj]: "Svalbard & Jan Mayen",
  [RedoShopifyCountryCode.Sk]: "Slovakia",
  [RedoShopifyCountryCode.Sl]: "Sierra Leone",
  [RedoShopifyCountryCode.Sm]: "San Marino",
  [RedoShopifyCountryCode.Sn]: "Senegal",
  [RedoShopifyCountryCode.So]: "Somalia",
  [RedoShopifyCountryCode.Sr]: "Suriname",
  [RedoShopifyCountryCode.Ss]: "South Sudan",
  [RedoShopifyCountryCode.St]: "São Tomé & Príncipe",
  [RedoShopifyCountryCode.Sv]: "El Salvador",
  [RedoShopifyCountryCode.Sx]: "Sint Maarten",
  [RedoShopifyCountryCode.Sy]: "Syria",
  [RedoShopifyCountryCode.Sz]: "Eswatini",
  [RedoShopifyCountryCode.Ta]: "Tristan da Cunha",
  [RedoShopifyCountryCode.Tc]: "Turks & Caicos Islands",
  [RedoShopifyCountryCode.Td]: "Chad",
  [RedoShopifyCountryCode.Tf]: "French Southern Territories",
  [RedoShopifyCountryCode.Tg]: "Togo",
  [RedoShopifyCountryCode.Th]: "Thailand",
  [RedoShopifyCountryCode.Tj]: "Tajikistan",
  [RedoShopifyCountryCode.Tk]: "Tokelau",
  [RedoShopifyCountryCode.Tl]: "Timor-Leste",
  [RedoShopifyCountryCode.Tm]: "Turkmenistan",
  [RedoShopifyCountryCode.Tn]: "Tunisia",
  [RedoShopifyCountryCode.To]: "Tonga",
  [RedoShopifyCountryCode.Tr]: "Türkiye",
  [RedoShopifyCountryCode.Tt]: "Trinidad & Tobago",
  [RedoShopifyCountryCode.Tv]: "Tuvalu",
  [RedoShopifyCountryCode.Tw]: "Taiwan",
  [RedoShopifyCountryCode.Tz]: "Tanzania",
  [RedoShopifyCountryCode.Ua]: "Ukraine",
  [RedoShopifyCountryCode.Ug]: "Uganda",
  [RedoShopifyCountryCode.Um]: "U.S. Outlying Islands",
  [RedoShopifyCountryCode.Us]: "United States",
  [RedoShopifyCountryCode.Uy]: "Uruguay",
  [RedoShopifyCountryCode.Uz]: "Uzbekistan",
  [RedoShopifyCountryCode.Va]: "Vatican City",
  [RedoShopifyCountryCode.Vc]: "St. Vincent & Grenadines",
  [RedoShopifyCountryCode.Ve]: "Venezuela",
  [RedoShopifyCountryCode.Vg]: "British Virgin Islands",
  [RedoShopifyCountryCode.Vi]: "U.S. Virgin Islands",
  [RedoShopifyCountryCode.Vn]: "Vietnam",
  [RedoShopifyCountryCode.Vu]: "Vanuatu",
  [RedoShopifyCountryCode.Wf]: "Wallis & Futuna",
  [RedoShopifyCountryCode.Ws]: "Samoa",
  [RedoShopifyCountryCode.Xk]: "Kosovo",
  [RedoShopifyCountryCode.Ye]: "Yemen",
  [RedoShopifyCountryCode.Yt]: "Mayotte",
  [RedoShopifyCountryCode.Za]: "South Africa",
  [RedoShopifyCountryCode.Zm]: "Zambia",
  [RedoShopifyCountryCode.Zw]: "Zimbabwe",
  [RedoShopifyCountryCode.Zz]: "Unknown Region",
};

export function isRedoShopifyCountryCode(
  countryCode: string,
): countryCode is RedoShopifyCountryCode {
  return Object.values(RedoShopifyCountryCode).includes(
    countryCode as RedoShopifyCountryCode,
  );
}

/**
 * Converts a RedoShopifyCountryCode to a Shopify CountryCode.
 * Returns undefined if the code is not valid in Shopify's API
 */
export function toShopifyCountryCode(
  code: RedoShopifyCountryCode,
): CountryCode | undefined {
  const stringValue = code as string;
  if (Object.values(CountryCode).includes(stringValue as CountryCode)) {
    return stringValue as CountryCode;
  }
  return undefined;
}

export function getCountryNameFromCode(
  countryCode: RedoShopifyCountryCode,
): string {
  return RedoShopifyCountryNames?.[countryCode] ?? countryCode;
}

export function tryCoalesceStringToRedoShopifyCountryCode(
  maybeCountryCodeOrFullCountryName: string,
): RedoShopifyCountryCode | undefined {
  /** No coalesce: already a valid country code */
  if (isRedoShopifyCountryCode(maybeCountryCodeOrFullCountryName)) {
    return maybeCountryCodeOrFullCountryName;
  }

  /** stage 1 coalesce: uppercase */
  const casedCountryCode = maybeCountryCodeOrFullCountryName.toUpperCase();
  if (isRedoShopifyCountryCode(casedCountryCode)) {
    return casedCountryCode;
  }

  /** stage 2 coalesce: compare by full name, lowercased & only alphabetical */
  function lowercasedOnlyAlphabetical(str: string) {
    return str.toLowerCase().replace(/[^a-z]/g, "");
  }

  const lookupCodeFromFullName = reverseRecord(RedoShopifyCountryNames);
  const lookupCodeFromLowercasedOnlyAlphabeticalFullName = Object.fromEntries(
    Object.entries(lookupCodeFromFullName).map(([name, code]) => [
      lowercasedOnlyAlphabetical(name),
      code,
    ]),
  );

  const lookupFromName =
    lookupCodeFromLowercasedOnlyAlphabeticalFullName[
      lowercasedOnlyAlphabetical(maybeCountryCodeOrFullCountryName)
    ];
  if (lookupFromName) {
    return lookupFromName;
  }

  /** Could not coalesce to a valid country code */

  return undefined;
}

export enum IsoThreeLetterCountryCode {
  MLT = "MLT",
  SYR = "SYR",
  SYC = "SYC",
  BRA = "BRA",
  ESP = "ESP",
  MNE = "MNE",
  LUX = "LUX",
  RWA = "RWA",
  CYM = "CYM",
  MKD = "MKD",
  STP = "STP",
  NLD = "NLD",
  GAB = "GAB",
  GEO = "GEO",
  TGO = "TGO",
  CYP = "CYP",
  SWE = "SWE",
  LBY = "LBY",
  GRC = "GRC",
  OMN = "OMN",
  MCO = "MCO",
  SSD = "SSD",
  CPV = "CPV",
  PRT = "PRT",
  JPN = "JPN",
  SLV = "SLV",
  NOR = "NOR",
  GBR = "GBR",
  TON = "TON",
  TLS = "TLS",
  TUR = "TUR",
  PAK = "PAK",
  TUN = "TUN",
  COL = "COL",
  BOL = "BOL",
  LBR = "LBR",
  QAT = "QAT",
  PYF = "PYF",
  TWN = "TWN",
  IMN = "IMN",
  PHL = "PHL",
  ECU = "ECU",
  KWT = "KWT",
  LVA = "LVA",
  LAO = "LAO",
  SWZ = "SWZ",
  ISL = "ISL",
  THA = "THA",
  BEL = "BEL",
  BGR = "BGR",
  PNG = "PNG",
  MWI = "MWI",
  GIN = "GIN",
  DEU = "DEU",
  VUT = "VUT",
  RUS = "RUS",
  MYS = "MYS",
  YEM = "YEM",
  TZA = "TZA",
  WSM = "WSM",
  IRL = "IRL",
  BRN = "BRN",
  DJI = "DJI",
  WLF = "WLF",
  ZWE = "ZWE",
  CAN = "CAN",
  ETH = "ETH",
  LKA = "LKA",
  POL = "POL",
  SOM = "SOM",
  BLZ = "BLZ",
  COK = "COK",
  MRT = "MRT",
  ATG = "ATG",
  GNQ = "GNQ",
  FRO = "FRO",
  MSR = "MSR",
  TJK = "TJK",
  AZE = "AZE",
  KIR = "KIR",
  AUS = "AUS",
  CHN = "CHN",
  ARE = "ARE",
  UKR = "UKR",
  TCA = "TCA",
  ITA = "ITA",
  AFG = "AFG",
  LBN = "LBN",
  AUT = "AUT",
  DMA = "DMA",
  GRL = "GRL",
  TCD = "TCD",
  NPL = "NPL",
  NCL = "NCL",
  MOZ = "MOZ",
  ARM = "ARM",
  KEN = "KEN",
  JEY = "JEY",
  BHS = "BHS",
  HRV = "HRV",
  KOR = "KOR",
  MLI = "MLI",
  VEN = "VEN",
  BTN = "BTN",
  FLK = "FLK",
  COM = "COM",
  LSO = "LSO",
  VCT = "VCT",
  KAZ = "KAZ",
  HTI = "HTI",
  IRQ = "IRQ",
  TKL = "TKL",
  MDV = "MDV",
  PRY = "PRY",
  LTU = "LTU",
  LIE = "LIE",
  PSE = "PSE",
  NER = "NER",
  MMR = "MMR",
  USA = "USA",
  KNA = "KNA",
  ABW = "ABW",
  UZB = "UZB",
  ARG = "ARG",
  ROU = "ROU",
  EGY = "EGY",
  ZMB = "ZMB",
  GRD = "GRD",
  PRI = "PRI",
  GNB = "GNB",
  MDG = "MDG",
  TTO = "TTO",
  ERI = "ERI",
  MEX = "MEX",
  SEN = "SEN",
  SVK = "SVK",
  IND = "IND",
  BRB = "BRB",
  BWA = "BWA",
  KHM = "KHM",
  GUF = "GUF",
  NIC = "NIC",
  JAM = "JAM",
  CZE = "CZE",
  MNG = "MNG",
  CHL = "CHL",
  BMU = "BMU",
  BHR = "BHR",
  KGZ = "KGZ",
  NZL = "NZL",
  NRU = "NRU",
  GUY = "GUY",
  ESH = "ESH",
  BEN = "BEN",
  MAR = "MAR",
  GTM = "GTM",
  COD = "COD",
  ASM = "ASM",
  AND = "AND",
  TUV = "TUV",
  DOM = "DOM",
  CRI = "CRI",
  REU = "REU",
  MAC = "MAC",
  NIU = "NIU",
  UGA = "UGA",
  ANT = "ANT",
  MTQ = "MTQ",
  PAN = "PAN",
  MDA = "MDA",
  CHE = "CHE",
  NGA = "NGA",
  PER = "PER",
  SGP = "SGP",
  ZAF = "ZAF",
  GLP = "GLP",
  SAU = "SAU",
  BDI = "BDI",
  MUS = "MUS",
  HKG = "HKG",
  CMR = "CMR",
  AIA = "AIA",
  BLR = "BLR",
  BGD = "BGD",
  NAM = "NAM",
  SLB = "SLB",
  AGO = "AGO",
  FRA = "FRA",
  GGY = "GGY",
  SPM = "SPM",
  LCA = "LCA",
  SDN = "SDN",
  GIB = "GIB",
  ALB = "ALB",
  HND = "HND",
  HUN = "HUN",
  SHN = "SHN",
  FJI = "FJI",
  SVN = "SVN",
  BFA = "BFA",
  JOR = "JOR",
  GMB = "GMB",
  COG = "COG",
  SLE = "SLE",
  CAF = "CAF",
  DZA = "DZA",
  SRB = "SRB",
  VNM = "VNM",
  VGB = "VGB",
  BIH = "BIH",
  CIV = "CIV",
  PRK = "PRK",
  URY = "URY",
  IRN = "IRN",
  FIN = "FIN",
  SUR = "SUR",
  CUB = "CUB",
  IDN = "IDN",
  DNK = "DNK",
  SMR = "SMR",
  TKM = "TKM",
  NFK = "NFK",
  ISR = "ISR",
  EST = "EST",
  GHA = "GHA",
}

export const Iso3CountryCodeToRedoShopifyCountryCode: Record<
  IsoThreeLetterCountryCode,
  RedoShopifyCountryCode
> = {
  [IsoThreeLetterCountryCode.MLT]: RedoShopifyCountryCode.Mt,
  [IsoThreeLetterCountryCode.SYR]: RedoShopifyCountryCode.Sy,
  [IsoThreeLetterCountryCode.SYC]: RedoShopifyCountryCode.Sc,
  [IsoThreeLetterCountryCode.BRA]: RedoShopifyCountryCode.Br,
  [IsoThreeLetterCountryCode.ESP]: RedoShopifyCountryCode.Es,
  [IsoThreeLetterCountryCode.MNE]: RedoShopifyCountryCode.Me,
  [IsoThreeLetterCountryCode.LUX]: RedoShopifyCountryCode.Lu,
  [IsoThreeLetterCountryCode.RWA]: RedoShopifyCountryCode.Rw,
  [IsoThreeLetterCountryCode.CYM]: RedoShopifyCountryCode.Ky,
  [IsoThreeLetterCountryCode.MKD]: RedoShopifyCountryCode.Mk,
  [IsoThreeLetterCountryCode.STP]: RedoShopifyCountryCode.St,
  [IsoThreeLetterCountryCode.NLD]: RedoShopifyCountryCode.Nl,
  [IsoThreeLetterCountryCode.GAB]: RedoShopifyCountryCode.Ga,
  [IsoThreeLetterCountryCode.GEO]: RedoShopifyCountryCode.Ge,
  [IsoThreeLetterCountryCode.TGO]: RedoShopifyCountryCode.Tg,
  [IsoThreeLetterCountryCode.CYP]: RedoShopifyCountryCode.Cy,
  [IsoThreeLetterCountryCode.SWE]: RedoShopifyCountryCode.Se,
  [IsoThreeLetterCountryCode.LBY]: RedoShopifyCountryCode.Ly,
  [IsoThreeLetterCountryCode.GRC]: RedoShopifyCountryCode.Gr,
  [IsoThreeLetterCountryCode.OMN]: RedoShopifyCountryCode.Om,
  [IsoThreeLetterCountryCode.MCO]: RedoShopifyCountryCode.Mc,
  [IsoThreeLetterCountryCode.SSD]: RedoShopifyCountryCode.Ss,
  [IsoThreeLetterCountryCode.CPV]: RedoShopifyCountryCode.Cv,
  [IsoThreeLetterCountryCode.PRT]: RedoShopifyCountryCode.Pt,
  [IsoThreeLetterCountryCode.JPN]: RedoShopifyCountryCode.Jp,
  [IsoThreeLetterCountryCode.SLV]: RedoShopifyCountryCode.Sv,
  [IsoThreeLetterCountryCode.NOR]: RedoShopifyCountryCode.No,
  [IsoThreeLetterCountryCode.GBR]: RedoShopifyCountryCode.Gb,
  [IsoThreeLetterCountryCode.TON]: RedoShopifyCountryCode.To,
  [IsoThreeLetterCountryCode.TLS]: RedoShopifyCountryCode.Tl,
  [IsoThreeLetterCountryCode.TUR]: RedoShopifyCountryCode.Tr,
  [IsoThreeLetterCountryCode.PAK]: RedoShopifyCountryCode.Pk,
  [IsoThreeLetterCountryCode.TUN]: RedoShopifyCountryCode.Tn,
  [IsoThreeLetterCountryCode.COL]: RedoShopifyCountryCode.Co,
  [IsoThreeLetterCountryCode.BOL]: RedoShopifyCountryCode.Bo,
  [IsoThreeLetterCountryCode.LBR]: RedoShopifyCountryCode.Lr,
  [IsoThreeLetterCountryCode.QAT]: RedoShopifyCountryCode.Qa,
  [IsoThreeLetterCountryCode.PYF]: RedoShopifyCountryCode.Pf,
  [IsoThreeLetterCountryCode.TWN]: RedoShopifyCountryCode.Tw,
  [IsoThreeLetterCountryCode.IMN]: RedoShopifyCountryCode.Im,
  [IsoThreeLetterCountryCode.PHL]: RedoShopifyCountryCode.Ph,
  [IsoThreeLetterCountryCode.ECU]: RedoShopifyCountryCode.Ec,
  [IsoThreeLetterCountryCode.KWT]: RedoShopifyCountryCode.Kw,
  [IsoThreeLetterCountryCode.LVA]: RedoShopifyCountryCode.Lv,
  [IsoThreeLetterCountryCode.LAO]: RedoShopifyCountryCode.La,
  [IsoThreeLetterCountryCode.SWZ]: RedoShopifyCountryCode.Sz,
  [IsoThreeLetterCountryCode.ISL]: RedoShopifyCountryCode.Is,
  [IsoThreeLetterCountryCode.THA]: RedoShopifyCountryCode.Th,
  [IsoThreeLetterCountryCode.BEL]: RedoShopifyCountryCode.Be,
  [IsoThreeLetterCountryCode.BGR]: RedoShopifyCountryCode.Bg,
  [IsoThreeLetterCountryCode.PNG]: RedoShopifyCountryCode.Pg,
  [IsoThreeLetterCountryCode.MWI]: RedoShopifyCountryCode.Mw,
  [IsoThreeLetterCountryCode.GIN]: RedoShopifyCountryCode.Gn,
  [IsoThreeLetterCountryCode.DEU]: RedoShopifyCountryCode.De,
  [IsoThreeLetterCountryCode.VUT]: RedoShopifyCountryCode.Vu,
  [IsoThreeLetterCountryCode.RUS]: RedoShopifyCountryCode.Ru,
  [IsoThreeLetterCountryCode.MYS]: RedoShopifyCountryCode.My,
  [IsoThreeLetterCountryCode.YEM]: RedoShopifyCountryCode.Ye,
  [IsoThreeLetterCountryCode.TZA]: RedoShopifyCountryCode.Tz,
  [IsoThreeLetterCountryCode.WSM]: RedoShopifyCountryCode.Ws,
  [IsoThreeLetterCountryCode.IRL]: RedoShopifyCountryCode.Ie,
  [IsoThreeLetterCountryCode.BRN]: RedoShopifyCountryCode.Bn,
  [IsoThreeLetterCountryCode.DJI]: RedoShopifyCountryCode.Dj,
  [IsoThreeLetterCountryCode.WLF]: RedoShopifyCountryCode.Wf,
  [IsoThreeLetterCountryCode.ZWE]: RedoShopifyCountryCode.Zw,
  [IsoThreeLetterCountryCode.CAN]: RedoShopifyCountryCode.Ca,
  [IsoThreeLetterCountryCode.ETH]: RedoShopifyCountryCode.Et,
  [IsoThreeLetterCountryCode.LKA]: RedoShopifyCountryCode.Lk,
  [IsoThreeLetterCountryCode.POL]: RedoShopifyCountryCode.Pl,
  [IsoThreeLetterCountryCode.SOM]: RedoShopifyCountryCode.So,
  [IsoThreeLetterCountryCode.BLZ]: RedoShopifyCountryCode.Bz,
  [IsoThreeLetterCountryCode.COK]: RedoShopifyCountryCode.Ck,
  [IsoThreeLetterCountryCode.MRT]: RedoShopifyCountryCode.Mr,
  [IsoThreeLetterCountryCode.ATG]: RedoShopifyCountryCode.Ag,
  [IsoThreeLetterCountryCode.GNQ]: RedoShopifyCountryCode.Gq,
  [IsoThreeLetterCountryCode.FRO]: RedoShopifyCountryCode.Fo,
  [IsoThreeLetterCountryCode.MSR]: RedoShopifyCountryCode.Ms,
  [IsoThreeLetterCountryCode.TJK]: RedoShopifyCountryCode.Tj,
  [IsoThreeLetterCountryCode.AZE]: RedoShopifyCountryCode.Az,
  [IsoThreeLetterCountryCode.KIR]: RedoShopifyCountryCode.Ki,
  [IsoThreeLetterCountryCode.AUS]: RedoShopifyCountryCode.Au,
  [IsoThreeLetterCountryCode.CHN]: RedoShopifyCountryCode.Cn,
  [IsoThreeLetterCountryCode.ARE]: RedoShopifyCountryCode.Ae,
  [IsoThreeLetterCountryCode.UKR]: RedoShopifyCountryCode.Ua,
  [IsoThreeLetterCountryCode.TCA]: RedoShopifyCountryCode.Tc,
  [IsoThreeLetterCountryCode.ITA]: RedoShopifyCountryCode.It,
  [IsoThreeLetterCountryCode.AFG]: RedoShopifyCountryCode.Af,
  [IsoThreeLetterCountryCode.LBN]: RedoShopifyCountryCode.Lb,
  [IsoThreeLetterCountryCode.AUT]: RedoShopifyCountryCode.At,
  [IsoThreeLetterCountryCode.DMA]: RedoShopifyCountryCode.Dm,
  [IsoThreeLetterCountryCode.GRL]: RedoShopifyCountryCode.Gl,
  [IsoThreeLetterCountryCode.TCD]: RedoShopifyCountryCode.Td,
  [IsoThreeLetterCountryCode.NPL]: RedoShopifyCountryCode.Np,
  [IsoThreeLetterCountryCode.NCL]: RedoShopifyCountryCode.Nc,
  [IsoThreeLetterCountryCode.MOZ]: RedoShopifyCountryCode.Mz,
  [IsoThreeLetterCountryCode.ARM]: RedoShopifyCountryCode.Am,
  [IsoThreeLetterCountryCode.KEN]: RedoShopifyCountryCode.Ke,
  [IsoThreeLetterCountryCode.JEY]: RedoShopifyCountryCode.Je,
  [IsoThreeLetterCountryCode.BHS]: RedoShopifyCountryCode.Bs,
  [IsoThreeLetterCountryCode.HRV]: RedoShopifyCountryCode.Hr,
  [IsoThreeLetterCountryCode.KOR]: RedoShopifyCountryCode.Kr,
  [IsoThreeLetterCountryCode.MLI]: RedoShopifyCountryCode.Ml,
  [IsoThreeLetterCountryCode.VEN]: RedoShopifyCountryCode.Ve,
  [IsoThreeLetterCountryCode.BTN]: RedoShopifyCountryCode.Bt,
  [IsoThreeLetterCountryCode.FLK]: RedoShopifyCountryCode.Fk,
  [IsoThreeLetterCountryCode.COM]: RedoShopifyCountryCode.Km,
  [IsoThreeLetterCountryCode.LSO]: RedoShopifyCountryCode.Ls,
  [IsoThreeLetterCountryCode.VCT]: RedoShopifyCountryCode.Vc,
  [IsoThreeLetterCountryCode.KAZ]: RedoShopifyCountryCode.Kz,
  [IsoThreeLetterCountryCode.HTI]: RedoShopifyCountryCode.Ht,
  [IsoThreeLetterCountryCode.IRQ]: RedoShopifyCountryCode.Iq,
  [IsoThreeLetterCountryCode.TKL]: RedoShopifyCountryCode.Tk,
  [IsoThreeLetterCountryCode.MDV]: RedoShopifyCountryCode.Mv,
  [IsoThreeLetterCountryCode.PRY]: RedoShopifyCountryCode.Py,
  [IsoThreeLetterCountryCode.LTU]: RedoShopifyCountryCode.Lt,
  [IsoThreeLetterCountryCode.LIE]: RedoShopifyCountryCode.Li,
  [IsoThreeLetterCountryCode.PSE]: RedoShopifyCountryCode.Ps,
  [IsoThreeLetterCountryCode.NER]: RedoShopifyCountryCode.Ne,
  [IsoThreeLetterCountryCode.MMR]: RedoShopifyCountryCode.Mm,
  [IsoThreeLetterCountryCode.USA]: RedoShopifyCountryCode.Us,
  [IsoThreeLetterCountryCode.KNA]: RedoShopifyCountryCode.Kn,
  [IsoThreeLetterCountryCode.ABW]: RedoShopifyCountryCode.Aw,
  [IsoThreeLetterCountryCode.UZB]: RedoShopifyCountryCode.Uz,
  [IsoThreeLetterCountryCode.ARG]: RedoShopifyCountryCode.Ar,
  [IsoThreeLetterCountryCode.ROU]: RedoShopifyCountryCode.Ro,
  [IsoThreeLetterCountryCode.EGY]: RedoShopifyCountryCode.Eg,
  [IsoThreeLetterCountryCode.ZMB]: RedoShopifyCountryCode.Zm,
  [IsoThreeLetterCountryCode.GRD]: RedoShopifyCountryCode.Gd,
  [IsoThreeLetterCountryCode.PRI]: RedoShopifyCountryCode.Pr,
  [IsoThreeLetterCountryCode.GNB]: RedoShopifyCountryCode.Gw,
  [IsoThreeLetterCountryCode.MDG]: RedoShopifyCountryCode.Mg,
  [IsoThreeLetterCountryCode.TTO]: RedoShopifyCountryCode.Tt,
  [IsoThreeLetterCountryCode.ERI]: RedoShopifyCountryCode.Er,
  [IsoThreeLetterCountryCode.MEX]: RedoShopifyCountryCode.Mx,
  [IsoThreeLetterCountryCode.SEN]: RedoShopifyCountryCode.Sn,
  [IsoThreeLetterCountryCode.SVK]: RedoShopifyCountryCode.Sk,
  [IsoThreeLetterCountryCode.IND]: RedoShopifyCountryCode.In,
  [IsoThreeLetterCountryCode.BRB]: RedoShopifyCountryCode.Bb,
  [IsoThreeLetterCountryCode.BWA]: RedoShopifyCountryCode.Bw,
  [IsoThreeLetterCountryCode.KHM]: RedoShopifyCountryCode.Kh,
  [IsoThreeLetterCountryCode.GUF]: RedoShopifyCountryCode.Gf,
  [IsoThreeLetterCountryCode.NIC]: RedoShopifyCountryCode.Ni,
  [IsoThreeLetterCountryCode.JAM]: RedoShopifyCountryCode.Jm,
  [IsoThreeLetterCountryCode.CZE]: RedoShopifyCountryCode.Cz,
  [IsoThreeLetterCountryCode.MNG]: RedoShopifyCountryCode.Mn,
  [IsoThreeLetterCountryCode.CHL]: RedoShopifyCountryCode.Cl,
  [IsoThreeLetterCountryCode.BMU]: RedoShopifyCountryCode.Bm,
  [IsoThreeLetterCountryCode.BHR]: RedoShopifyCountryCode.Bh,
  [IsoThreeLetterCountryCode.KGZ]: RedoShopifyCountryCode.Kg,
  [IsoThreeLetterCountryCode.NZL]: RedoShopifyCountryCode.Nz,
  [IsoThreeLetterCountryCode.NRU]: RedoShopifyCountryCode.Nr,
  [IsoThreeLetterCountryCode.GUY]: RedoShopifyCountryCode.Gy,
  [IsoThreeLetterCountryCode.ESH]: RedoShopifyCountryCode.Eh,
  [IsoThreeLetterCountryCode.BEN]: RedoShopifyCountryCode.Bj,
  [IsoThreeLetterCountryCode.MAR]: RedoShopifyCountryCode.Ma,
  [IsoThreeLetterCountryCode.GTM]: RedoShopifyCountryCode.Gt,
  [IsoThreeLetterCountryCode.COD]: RedoShopifyCountryCode.Cd,
  [IsoThreeLetterCountryCode.ASM]: RedoShopifyCountryCode.As,
  [IsoThreeLetterCountryCode.AND]: RedoShopifyCountryCode.Ad,
  [IsoThreeLetterCountryCode.TUV]: RedoShopifyCountryCode.Tv,
  [IsoThreeLetterCountryCode.DOM]: RedoShopifyCountryCode.Do,
  [IsoThreeLetterCountryCode.CRI]: RedoShopifyCountryCode.Cr,
  [IsoThreeLetterCountryCode.REU]: RedoShopifyCountryCode.Re,
  [IsoThreeLetterCountryCode.MAC]: RedoShopifyCountryCode.Mo,
  [IsoThreeLetterCountryCode.NIU]: RedoShopifyCountryCode.Nu,
  [IsoThreeLetterCountryCode.UGA]: RedoShopifyCountryCode.Ug,
  [IsoThreeLetterCountryCode.ANT]: RedoShopifyCountryCode.An,
  [IsoThreeLetterCountryCode.MTQ]: RedoShopifyCountryCode.Mq,
  [IsoThreeLetterCountryCode.PAN]: RedoShopifyCountryCode.Pa,
  [IsoThreeLetterCountryCode.MDA]: RedoShopifyCountryCode.Md,
  [IsoThreeLetterCountryCode.CHE]: RedoShopifyCountryCode.Ch,
  [IsoThreeLetterCountryCode.NGA]: RedoShopifyCountryCode.Ng,
  [IsoThreeLetterCountryCode.PER]: RedoShopifyCountryCode.Pe,
  [IsoThreeLetterCountryCode.SGP]: RedoShopifyCountryCode.Sg,
  [IsoThreeLetterCountryCode.ZAF]: RedoShopifyCountryCode.Za,
  [IsoThreeLetterCountryCode.GLP]: RedoShopifyCountryCode.Gp,
  [IsoThreeLetterCountryCode.SAU]: RedoShopifyCountryCode.Sa,
  [IsoThreeLetterCountryCode.BDI]: RedoShopifyCountryCode.Bi,
  [IsoThreeLetterCountryCode.MUS]: RedoShopifyCountryCode.Mu,
  [IsoThreeLetterCountryCode.HKG]: RedoShopifyCountryCode.Hk,
  [IsoThreeLetterCountryCode.CMR]: RedoShopifyCountryCode.Cm,
  [IsoThreeLetterCountryCode.AIA]: RedoShopifyCountryCode.Ai,
  [IsoThreeLetterCountryCode.BLR]: RedoShopifyCountryCode.By,
  [IsoThreeLetterCountryCode.BGD]: RedoShopifyCountryCode.Bd,
  [IsoThreeLetterCountryCode.NAM]: RedoShopifyCountryCode.Na,
  [IsoThreeLetterCountryCode.SLB]: RedoShopifyCountryCode.Sb,
  [IsoThreeLetterCountryCode.AGO]: RedoShopifyCountryCode.Ao,
  [IsoThreeLetterCountryCode.FRA]: RedoShopifyCountryCode.Fr,
  [IsoThreeLetterCountryCode.GGY]: RedoShopifyCountryCode.Gg,
  [IsoThreeLetterCountryCode.SPM]: RedoShopifyCountryCode.Pm,
  [IsoThreeLetterCountryCode.LCA]: RedoShopifyCountryCode.Lc,
  [IsoThreeLetterCountryCode.SDN]: RedoShopifyCountryCode.Sd,
  [IsoThreeLetterCountryCode.GIB]: RedoShopifyCountryCode.Gi,
  [IsoThreeLetterCountryCode.ALB]: RedoShopifyCountryCode.Al,
  [IsoThreeLetterCountryCode.HND]: RedoShopifyCountryCode.Hn,
  [IsoThreeLetterCountryCode.HUN]: RedoShopifyCountryCode.Hu,
  [IsoThreeLetterCountryCode.SHN]: RedoShopifyCountryCode.Sh,
  [IsoThreeLetterCountryCode.FJI]: RedoShopifyCountryCode.Fj,
  [IsoThreeLetterCountryCode.SVN]: RedoShopifyCountryCode.Si,
  [IsoThreeLetterCountryCode.BFA]: RedoShopifyCountryCode.Bf,
  [IsoThreeLetterCountryCode.JOR]: RedoShopifyCountryCode.Jo,
  [IsoThreeLetterCountryCode.GMB]: RedoShopifyCountryCode.Gm,
  [IsoThreeLetterCountryCode.COG]: RedoShopifyCountryCode.Cg,
  [IsoThreeLetterCountryCode.SLE]: RedoShopifyCountryCode.Sl,
  [IsoThreeLetterCountryCode.CAF]: RedoShopifyCountryCode.Cf,
  [IsoThreeLetterCountryCode.DZA]: RedoShopifyCountryCode.Dz,
  [IsoThreeLetterCountryCode.SRB]: RedoShopifyCountryCode.Rs,
  [IsoThreeLetterCountryCode.VNM]: RedoShopifyCountryCode.Vn,
  [IsoThreeLetterCountryCode.VGB]: RedoShopifyCountryCode.Vg,
  [IsoThreeLetterCountryCode.BIH]: RedoShopifyCountryCode.Ba,
  [IsoThreeLetterCountryCode.CIV]: RedoShopifyCountryCode.Ci,
  [IsoThreeLetterCountryCode.PRK]: RedoShopifyCountryCode.Kp,
  [IsoThreeLetterCountryCode.URY]: RedoShopifyCountryCode.Uy,
  [IsoThreeLetterCountryCode.IRN]: RedoShopifyCountryCode.Ir,
  [IsoThreeLetterCountryCode.FIN]: RedoShopifyCountryCode.Fi,
  [IsoThreeLetterCountryCode.SUR]: RedoShopifyCountryCode.Sr,
  [IsoThreeLetterCountryCode.CUB]: RedoShopifyCountryCode.Cu,
  [IsoThreeLetterCountryCode.IDN]: RedoShopifyCountryCode.Id,
  [IsoThreeLetterCountryCode.DNK]: RedoShopifyCountryCode.Dk,
  [IsoThreeLetterCountryCode.SMR]: RedoShopifyCountryCode.Sm,
  [IsoThreeLetterCountryCode.TKM]: RedoShopifyCountryCode.Tm,
  [IsoThreeLetterCountryCode.NFK]: RedoShopifyCountryCode.Nf,
  [IsoThreeLetterCountryCode.ISR]: RedoShopifyCountryCode.Il,
  [IsoThreeLetterCountryCode.EST]: RedoShopifyCountryCode.Ee,
  [IsoThreeLetterCountryCode.GHA]: RedoShopifyCountryCode.Gh,
};

// https://european-union.europa.eu/principles-countries-history/eu-countries_en
export const europeanUnionCountryCodes: RedoShopifyCountryCode[] = [
  RedoShopifyCountryCode.At,
  RedoShopifyCountryCode.Be,
  RedoShopifyCountryCode.Bg,
  RedoShopifyCountryCode.Cy,
  RedoShopifyCountryCode.Cz,
  RedoShopifyCountryCode.Dk,
  RedoShopifyCountryCode.De,
  RedoShopifyCountryCode.Ee,
  RedoShopifyCountryCode.Es,
  RedoShopifyCountryCode.Fi,
  RedoShopifyCountryCode.Fr,
  RedoShopifyCountryCode.Gr,
  RedoShopifyCountryCode.Hr,
  RedoShopifyCountryCode.Hu,
  RedoShopifyCountryCode.Ie,
  RedoShopifyCountryCode.It,
  RedoShopifyCountryCode.Lv,
  RedoShopifyCountryCode.Lt,
  RedoShopifyCountryCode.Lu,
  RedoShopifyCountryCode.Mt,
  RedoShopifyCountryCode.Nl,
  RedoShopifyCountryCode.Pl,
  RedoShopifyCountryCode.Pt,
  RedoShopifyCountryCode.Ro,
  RedoShopifyCountryCode.Sk,
  RedoShopifyCountryCode.Si,
  RedoShopifyCountryCode.Se,
];

export function tryGetRedoShopifyCountryCode(
  input: string,
): RedoShopifyCountryCode | null {
  try {
    return getRedoShopifyCountryCode(input);
  } catch (error) {
    return null;
  }
}

export function getRedoShopifyCountryCode(
  input: string,
): RedoShopifyCountryCode | null {
  let countryCode: RedoShopifyCountryCode | null = null;
  if (isEnumValue(input, RedoShopifyCountryCode)) {
    countryCode = input;
  } else if (isEnumValue(input, IsoThreeLetterCountryCode)) {
    countryCode =
      Iso3CountryCodeToRedoShopifyCountryCode[
        input as IsoThreeLetterCountryCode
      ];
  } else {
    throw new Error(`Unknown country code: ${input}`);
  }
  return countryCode;
}
